import { Plugins } from '@leverege/plugin';
export const ImagineFilterConverterFactory = Plugins.createFactory('ImagineConditionFilterConverter', {
  pluginKey: 'convert'
});
export const ImagineHistoryFilterConverterFactory = Plugins.createFactory('ImagineHistoryConditionFilterConverter', {
  pluginKey: 'convert'
});
export const ImagineComparatorConverterFactory = Plugins.createFactory('ImagineComparatorFilterConverter', {
  pluginKey: 'convert'
});
export const ImagineSortConverterFactory = Plugins.createFactory('ImagineAttributeSortConverter', {
  pluginKey: 'convert'
});
export const ImagineHistorySortConverterFactory = Plugins.createFactory('ImagineHistoryAttributeSortConverter', {
  pluginKey: 'convert'
});
export const ImagineHistoryComparatorConverterFactory = Plugins.createFactory('ImagineHistoryComparatorFilterConverter', {
  pluginKey: 'convert'
});